import useDialog from "@/composables/useDialog"
import { i18n } from "@/plugins/vue-i18n"
import { DialogTypes } from "@/store/modules/dialog/dialogTypes"
import store from "@/store/store"
import { ModuleNamespaces } from "@/store/types/storeGlobalTypes"
import { useI18n } from "vue-i18n-composable"
import { FileInfo } from "../UploaderTypes"

interface ResponseUseUploaderDialog {
  duplicatedDialog: (message: string, buttons: any) => void
  duplicateErrorDialog: (filename: string, isFile?: boolean) => void
  cancelDialog: (callback: () => void) => void
  getDuplicatedDialogMessage: (duplicatedFile: FileInfo[]) => string
  cantUploapDialog: () => void
}

export default function useUploaderDialog(): ResponseUseUploaderDialog {
  const { t } = useI18n()

  const { getDialog, getDialogError, getDialogInfo } = useDialog()

  const cancelPendingRequests = async () => {
    store.dispatch(`${ModuleNamespaces.AUTH}/cancelPendingRequests`)
  }

  const duplicateErrorDialog = (filename: string, isFile = true) => {
    const message = isFile
      ? i18n.t('components.file_manager.dialogs.duplicated_file', { filename }).toString()
      : i18n.t('components.file_manager.dialogs.duplicated_folder', { filename }).toString()

    getDialogError({
      message
    })
  }

  function getDuplicatedDialogMessage(duplicatedFile: FileInfo[]) {
    const multiple = duplicatedFile.length > 1
    if (multiple) {
      return t('components.file_manager.dialogs.duplicated_multiple_files').toString()
    }
    const { isFile, name } = duplicatedFile[0]
    return isFile
                  ? t('components.file_manager.dialogs.duplicated_file_question', { filename: name }).toString()
                  : t('components.file_manager.dialogs.duplicated_folder', { filename: name }).toString()
  }

  const duplicatedDialog = (message: string, buttons: any) => {
    getDialog({
      type: DialogTypes.INFO,
      message,
      buttons
    })
  }

  const cantUploapDialog = () => {
    getDialogInfo({
      message: t('components.file_manager.dialogs.cant_upload_files_here').toString(),
      hideSecondaryButton: true
    })
  }


  const cancelDialog = (callback: () => void) => {
    getDialog({
      type: DialogTypes.WARNING,
      message: t('components.file_manager.dialogs.cancel_upload_folder').toString(),
      action: () => {
        cancelPendingRequests()
        callback()
      }
    })
  }

  return {
    cantUploapDialog,
    getDuplicatedDialogMessage,
    duplicatedDialog,
    duplicateErrorDialog,
    cancelDialog
  }
}
